import React, { useState, useEffect,useRef } from "react";
import LinkButton from "./LinkButton";
//Import Icons
import SearchIcon from "../../images/library-searchIcon.svg"
import clearTextIcon from "../../images/clearTextIcon.svg";

//Import styles
import "./RoundedSearchTextField.scss";

const RoundedSearchTextField = ({
  inlineButton = false,
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  isResetClicked,
  expandable,
  inputValue = "",
  handleCrossIcon,
  fetchAllTemplates,
  setIsSearchBarEmpty ,
  isSearchBarEmpty
}) => {
  const searchButtonRef=useRef("")
  // const [isSearchBarEmpty, setIsSearchBarEmpty] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
   useEffect(() => {
     if (isResetClicked) {
     clearTextField();
     handleCrossIcon()
     }
   }, [isResetClicked]);
   useEffect(() => {
     if (inputValue && inputValue.trim()) {
      setIsSearchBarEmpty(false);
     } else {
       setIsSearchBarEmpty(true);
    }
   }, [inputValue]);
  const handleFocus = () => {
    setIsFocused(true);
  };

  // const handleBlur = () => {
  //   setIsFocused(false);
  // };
  const handleBlur = (e) => {
    
    // setTimeout(() => {
     
    //   if (!searchButtonRef.current || !searchButtonRef.current.contains(e.relatedTarget)) {
    //    return
    //   }
      setIsFocused(false); 
    // }, 0);
  };
  const clearTextField = () => {
    const element = document.getElementById("tf-search-field");
    if (element) {
      element.value = "";
      setIsSearchBarEmpty(true);
      onTextChange(element.value);
    }

  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
  };
  const handleSearchClick = (event) => {
   
    handleSearch(event);
  };
  return (
    <div className={`tf-rounded-search ${expandable ? "expandable" : ""}`}>
      <div className="d-flex align-items-center">
        <img src={SearchIcon} alt="" className="search-icon" />
        <input
          id="tf-search-field"
          type="text"
          value={inputValue || ""}
          placeholder={placeholder}
          className="search-input"
          autoComplete="off"
          onKeyPress={handleKeyPress}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onDrop={(e) => e.preventDefault()} // Prevents default behavior of dropping files
          onChange={(e) => {
            const value = e.target.value;
            if (value.length === 1 && value.startsWith(" ")) {
              return;
            }
            if (e.target.value?.trim().length > 0) {
              setIsSearchBarEmpty(false);
            } else {
              setIsSearchBarEmpty(true);
            }
            onTextChange(e.target.value);
          }}
        />

        {inlineButton && (
          <LinkButton
          ref={searchButtonRef}
            className=""
            handleClick={(event) => {
              handleSearchClick(event);
            }}
            disabled={isSearchBarEmpty}
            title="SEARCH"
            height="32px"
          />
        )}

        {inputValue.length > 0 && (
          <img
            src={clearTextIcon}
            alt=""
            className=""
            style={{ cursor: "pointer" }}
            onClick={(event) => {
              clearTextField();
             // handleCrossIcon();
             
              //handleSearchClick("searchBarEmpty");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RoundedSearchTextField;
